<template>
	<div class="flex gap-x-6">
		<div
			v-if="locale == 'de'"
			class="sm:w-3/5 py-6 pl-6 pr-12 space-y-6 text-lg"
		>
			<h2 class="text-2xl font-semibold text-gray-900">
				Vielen Dank für die Vervollständigung Ihres Profils!
			</h2>
			<p>
				Sicherheit steht bei uns an oberster Stelle! Damit Sie auf die
				Vertrauenswürdigkeit Ihrer Kontraktpartner zählen können, werden die
				Stammdaten von cropspot überprüft.
			</p>
			<p>
				Bitte haben Sie Verständnis, dass Sie bis zur vollständigen Prüfung (~15
				Minuten) cropspot nur eingeschränkt nutzen können. Vielen Dank!
			</p>
		</div>
		<div v-else class="w-3/5 py-6 pl-6 pr-12 space-y-6 text-lg">
			<h2 class="text-2xl font-semibold text-gray-900">
				Thank you for completing your profile!
			</h2>
			<p>
				Security is our top priority! To ensure that you can rely on the
				trustworthiness of your contract partners, cropspot checks your data.
			</p>
			<p>
				Please note that you will only be able to use cropspot in a limited way
				until the check is complete (approx. 15 minutes). Thank you very much!
			</p>
		</div>

		<div class="hidden sm:block sm:w-2/5 pb-3">
			<img :src="imageUrl" class="rounded-xl shadow-xl border-gray-500" />
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		imageUrl: () => window.baseUrl + "/images/full-features-screenshot.png",
	},
};
</script>
